export const Mutations = {
  achievements: {
    setAchievements: 'SET_ACHIEVEMENTS',
    setFilteredAchievements: 'SET_FILTERED_ACHIEVEMENTS',
    setAchievementTypesCount: 'SET_ACHIEVEMENTS_TYPES_COUNT',
    setGeekAchievementTypesCount: 'SET_GEEK_ACHIEVEMENTS_COUNT',
    setGeekAchievements: 'SET_GEEK_ACHIEVEMENTS',
    setHistory: 'SET_ACHIEVEMENTS_HISTORY',
    setAchievementTypeIdSharedFilter: 'SET_ACHIEVEMENT_TYPE_ID_SHARED_FILTER',
    resetPagination: 'RESET_ACHIEVEMENTS_HISTORY_PAGINATION',
    resetFilteredAchievements: 'RESET_FILTERED_ACHIEVEMENTS',
    incrementPagination: 'INCREMENT_ACHIEVEMENTS_HISTORY_PAGINATION',
    addHistory: 'ADD_ACHIEVEMENTS_HISTORY',
    addMoreAchievements: 'ADD_MORE_ACHIEVEMENTS',
    setAchievementsCount: 'SET_ACHIEVEMENTS_COUNT',
  },
  activities: {
    setAll: 'SET_ALL_ACTIVITIES',
    setRequests: 'SET_REQUESTS',
    setGratifications: 'SET_GRATIFICATIONS',
    addRequests: 'ADD_REQUESTS',
    resetPagination: 'RESET_PAGINATION',
    incrementPagination: 'INCREMENT_PAGINATION',
    setRequestsCount: 'SET_REQUESTS_COUNT',
    setGeekActivities: 'SET_GEEK_ACTIVITIES',
    setRecentActivities: 'SET_RECENT_ACTIVITIES',
    setActivitiesHistory: 'SET_ACTIVITIES_HISTORY',
    addActivitiesHistory: 'ADD_ACTIVITIES_HISTORY',
    setWaitingActivityRequests: 'SET_WAITING_ACTIVITY_REQUEST',
  },
  badges: {
    setBadges: 'SET_BADGES',
    setGeekBadgesCount: 'SET_GEEK_BADGES_COUNT',
    setGeekBadges: 'SET_GEEK_BADGES',
  },
  gCoins: {
    setActivities: 'SET_GCOINS_ACTIVITIES',
    setHistory: 'SET_GCOINS_HISTORY',
    setHistoryWithGeek: 'SET_GCOINS_HISTORY_WITH_GEEK',
    setWithdrawalsToExport: 'SET_WITHDRAWALS_TO_EXPORT',
    setWaitingWithdrawals: 'SET_WAITING_WITHDRAWALS',
    setWaitingRequests: 'SET_WAITING_REQUESTS',
    addHistoryElements: 'ADD_GCOINS_HISTORY_ELEMENTS',
    addHistoryWithGeekElements: 'ADD_GCOINS_HISTORY_WITH_GEEK_ELEMENTS',
    setElementsCount: 'SET_GCOINS_ELEMENTS_COUNT',
    resetPagination: 'RESET_GCOINS_HISTORY_PAGINATION',
    incrementPagination: 'INCREMENT_GCOINS_HISTORY_PAGINATION',
    setBalanceEntries: 'SET_GCOINS_BALANCE',
    addBalanceEntries: 'ADD_GCOINS_BALANCE',
    setAllGeeksBalance: 'SET_ALL_GEEKS_BALANCE',
    setGCoinsFromFile: 'SET_GCOINS_FROM_FILE',
    resetGCoinsToImport: ' RESET_GCOINS_TO_IMPORT',
  },
  geek: {
    setCurrent: 'SET_CURRENT_GEEK',
    setGeekBasicInfo: 'SET_GEEK_BASIC_INFO',
    setGeeks: 'SET_ALL_GEEKS',
    setAdmins: 'SET_ADMINS',
    setSuperAdmins: 'SET_SUPER_ADMINS',
    setSearchPhrase: 'SET_SEARCH_PHRASE',
    clearSearch: 'CLEAR_SEARCH',
    setCsrfToken: 'SET_CSRF_TOKEN',
    setGeekJobInfo: 'SET_GEEK_JOB_INFO',
    resetGeeks: 'RESET_GEEKS',
    setGeekIdSharedFilter: 'SET_GEEK_ID_SHARED_FILTER',
  },
  guides: {
    setAllGuides: 'SET_ALL_GUIDES',
    setGuideSteps: 'SET_GUIDE_STEPS',
    setGuideMasterBasicInfo: 'SET_GUIDE_MASTER_BASIC_INFO',
    setGuideUserBasicInfo: 'SET_GUIDE_USER_BASIC_INFO',
  },
  history: {
    setLatestAccomplishment: 'SET_LATEST_ACCOMPLISHMENT',
    setGeekHistory: 'SET_GEEK_HISTORY',
    setHistoryElementsCount: 'SET_HISTORY_ELEMENTS_COUNT',
    resetPagination: 'RESET_PAGINATION',
    addHistoryElements: 'ADD_HISTORY_ELEMENTS',
    incrementPagination: 'INCREMENT_PAGINATION',
  },
  kitchenTv: {
    setLeaderboard: 'SET_LEADERBOARD_FOR_TV',
    setRecentActivities: 'SET_RECENT_ACTIVITIES_FOR_TV',
    setLatestKudosPhotos: 'SET_LATEST_KUDOS_PHOTOS_FOR_TV',
    setOpportunities: 'SET_OPPORTUNITIES_FOR_TV',
  },
  management: {
    geeksManagement: {
      setGeeks: 'SET_GEEKS_WITH_STATUS',
      incrementPagination: 'INCREMENT_GEEKS_WITH_STATUS_PAGINATION',
      resetPagination: 'RESET_GEEKS_WITH_STATUS_PAGINATION',
      setGeeksCount: 'SET_GEEKS_WITH_STATUS_COUNT',
      addGeeksWithStatus: 'ADD_GEEKS_WITH_STATUS',
      setGeekStatus: 'SET_GEEK_STATUS',
      setAccessRequests: 'SET_ACCESS_REQUESTS',
    },
  },
  news: {
    setNews: 'FETCH_NEWS',
    setNewsElementsCount: 'SET_NEWS_ELEMENTS_COUNT',
    resetPagination: 'RESET_NEWS_PAGINATION',
    resetAdminPagination: 'RESET_NEWS_ADMIN_PAGINATION',
    addNewsElements: 'ADD_NEWS_ELEMENTS',
    incrementPagination: 'INCREMENT_PAGINATION',
    incrementAdminPagination: 'INCREMENT_ADMIN_PAGINATION',
    setNewsToEdit: 'SET_NEWS_TO_EDIT',
  },
  notifications: {
    set: 'SET_NOTIFICATIONS',
  },
  opportunities: {
    setOpportunities: 'SET_OPPORTUNITIES',
    addOpportunities: 'ADD_OPPORTUNITIES',
    setNews: 'SET_OPPORTUNITIES_NEWS',
    setCurrent: 'SET_CURRENT',
    setFinalizationFormData: 'SET_FINALIZATION_FORM_DATA',
    setDepartments: 'SET_DEPARTMENTS',
    setLevels: 'SET_LEVELS',
    setTags: 'SET_TAGS',
    setPopularTags: 'SET_POPULAR_TAGS',
    setGeeksWithRoles: 'SET_OPPORTUNITY_GEEKS_WITH_ROLES',
    setCandidates: 'SET_OPPORTUNITY_CANDIDATES',
    setCandidatesSearchPhrase: 'SET_OPPORTUNITY_CANDIDATES_SEARCH_PHRASE',
    resetPagination: 'RESET_OPPORTUNITY_GEEKS_WITH_ROLES_PAGINATION',
    incrementPagination: 'INCREMENT_OPPORTUNITY_GEEKS_WITH_ROLES_PAGINATION',
    setElementsCount: 'SET_ELEMENTS_COUNT',
    addGeeksWithRoles: 'ADD_OPPORTUNITY_GEEKS_WITH_ROLES',
    setCounters: 'SET_OPPORTUNITIES_COUNTERS',
    setCreators: 'SET_OPPORTUNITY_CREATORS',
    setIssuers: 'SET_OPPORTUNITY_ISSUERS',
    setApprovers: 'SET_OPPORTUNITY_APPROVERS',
    setAdmins: 'SET_OPPORTUNITY_ADMINS',
    setGeekOpportunitiesCount: 'SET_GEEK_OPPORTUNITIES_COUNT',
    setNewMember: 'SET_NEW_MEMBER',
    resetCandidates: 'RESET_CANDIDATES',
    drafts: {
      setOpportunitiesDrafts: 'SET_OPPORTUNITIES_DRAFTS',
      addOpportunitiesDrafts: 'ADD_OPPORTUNITY_DRAFT',
      setCurrent: 'SET_CURRENT_OPPORTUNITY_DRAFT',
    },
  },
  rules: {
    setLargeScreen: 'SET_LARGE_SCREEN',
  },
  scores: {
    setGeekGeneralScore: 'SET_GEEK_GENERAL_SCORE',
    setGeekGeneralPosition: 'SET_GEEK_GENERAL_POSITION',
    setGeekSkillScores: 'SET_GEEK_SKILL_SCORES',
    setLeaderboard: 'SET_LEADERBOARD',
    setLeaderboardGeeksCount: 'SET_LEADERBOARD_GEEKS_COUNT',
    resetPagination: 'RESET_LEADERBOARD_PAGINATION',
    addLeaderboardGeeks: 'ADD_LEADERBOARD_GEEKS',
    incrementPagination: 'INCREMENT_LEADERBOARD_PAGINATION',
    setGeekPersonalBest: 'SET_GEEK_PERSONAL_BEST',
  },
  seasons: {
    setCurrentSeason: 'SET_CURRENT_SEASON',
    setAllSeasons: 'SET_ALL_SEASONS',
  },
  themes: {
    setCurrentTheme: 'SET_CURRENT_THEME',
  },
  users: {
    setCurrentUserStatus: 'SET_CURRENT_USER_STATUS',
  },
};
